import styled from "styled-components";
import {STICKY} from "../../../../themes/css-global-classes";
import {LobbyHeaderLineDefaultBox} from "./lobby-header-line.default.box";

export const LobbyHeaderLineCasino888WsopBox = styled(LobbyHeaderLineDefaultBox)`
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        width: 100%;
        border-top: none;
        border-bottom: 1px solid ${props => props.theme.colors.boxBorderLight};
        
        /** Duplicated these rules for specificity. otherwise the ones from the base class will apply. */
        .${STICKY} &{
            width: 100%;
            border-top: none;
            border-bottom: 1px solid ${props => props.theme.colors.boxBorderLight};
        }
    }
`;
